import AsideControls from "../../../components/aside-controls";
import Toc from "../../components/toc";
import { WikiTocMobile } from "../../components/wiki-toc-mobile";

export default class PageModule {
    constructor() {
        this.initToc();
        this.initAsideControls();
    }

    initToc() {
        const toc = new Toc(null, WikiTocMobile, { shouldAnimateScroll: false });
    }

    initAsideControls() {
        const asideControls = new AsideControls({ shouldAnimateScroll: false });
    }
}